// Bottom-bar controls + global keyboard capture.
// Keyboard:  ←/→ ↑/↓ Space PageUp PageDown — passed to deck iframe Reveal.
//            Esc — toggle overview.
//            B   — toggle blackout/pause.

export default {
  id:   'nav-controls',
  slot: 'nav-controls',
  mount({ slot, deck }) {
    slot.innerHTML = `
      <button data-cmd="prev">◀ Prev</button>
      <button data-cmd="next" class="primary">Next ▶</button>
      <button data-cmd="overview">Overview</button>
      <button data-cmd="blackout">Blackout</button>
    `;

    const cmd = (c) => {
      switch (c) {
        case 'prev':     deck.prev(); break;
        case 'next':     deck.next(); break;
        case 'left':     deck.left(); break;
        case 'right':    deck.right(); break;
        case 'up':       deck.up(); break;
        case 'down':     deck.down(); break;
        case 'overview': deck.toggleOverview(); break;
        case 'blackout': deck.toggleBlackout(); break;
      }
    };

    slot.querySelectorAll('button').forEach(btn =>
      btn.addEventListener('click', () => cmd(btn.dataset.cmd)));

    window.addEventListener('keydown', (e) => {
      // Don't hijack typing in inputs.
      if (e.target.matches?.('input, textarea, select')) return;
      const map = {
        ArrowLeft:  'left',
        ArrowRight: 'right',
        ArrowUp:    'up',
        ArrowDown:  'down',
        ' ':        'next',
        PageDown:   'next',
        PageUp:     'prev',
        Escape:     'overview',
        b:          'blackout',
        B:          'blackout',
      };
      const c = map[e.key];
      if (!c) return;
      e.preventDefault();
      cmd(c);
    });
  },
};
